import React from "react";
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from "lucide-react";
import { Link } from "react-router-dom"; // Add this import

const Footer = () => {
  const footerLinks = {
    "DonatePe": ["How It Works", "Success Stories", "Our Mission"],
    "Resources": ["Help Center","","","","",""],
    "Legal": ["Terms of Service", "Privacy Policy","","",""],
    "Connect": ["Contact Us", "Facebook", "Instagram", "YouTube"],
  };

  // const socialIcons = [
  //   { IconComponent: Facebook, label: "Facebook", href: "https://www.facebook.com/Givesendgo" },
  //   { IconComponent: Twitter, label: "Twitter", href: "https://x.com/GiveSendGo" },
  //   { IconComponent: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/givesendgo-com" },
  //   { IconComponent: Youtube, label: "YouTube", href: "https://www.youtube.com/channel/UCJH25w0hSD6Kx_hud1rVWuw" },
  //   { IconComponent: Instagram, label: "Instagram", href: "https://www.instagram.com/givesendgo" },
  // ];

  return (
    <>
      {/* Support Footer */}
      <section className="support-footer flex flex-col items-center justify-center relative bg-gradient-to-r from-blue-900 to-blue-600 py-16 px-4">
        <h3 className="text-5xl font-bold mb-4 text-white">DonatePe</h3>
        <p className="text-center mb-4 text-white text-lg">
          The place where help and hope go hand in hand.
        </p>
        <div className="flex flex-col items-center justify-center min-[400px]:flex-row mb-12 w-full gap-4">
          {/* Use Link for internal navigation */}
          <Link 
            to="/site/signup_email" 
            id="start-camp-footer" 
            className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-full text-lg transition-colors"
          >
            Start a DonatePe
          </Link>
          <Link 
            to="/FundGSG" 
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-3 rounded-full text-lg transition-colors"
          >
            Support DonatePe
          </Link>
        </div>
      </section>

      {/* Main Footer */}
      <footer className="bg-gradient-to-r from-blue-900 to-black pt-8 md:pt-10 xl:pt-16">
        <div className="max-w-7xl mx-auto px-4">
          {/* Logo */}
          <div className="flex flex-row items-center justify-center mb-12">
            {/* <Link to="/">
              <img 
                src="https://static2.givesendgo.com/vue/gsg-logo-all-white.png" 
                className="max-w-[280px] sm:max-w-xs" 
                alt="GiveSendGo Logo"
              />
            </Link> */}
                          <Link to="/" id="logo__link">
  <span className="text-white font-bold text-6xl">
    DonatePe
  </span>
</Link>
          </div>

          <div className="flex flex-col pb-4 xl:flex-row lg:pb-8">
            {/* Newsletter + Social */}
            <div className="flex flex-col items-center justify-center align-middle xl:basis-2/5 lg:basis-auto xl:items-start xl:pr-8">
              <div className="px-5 mb-3 text-left sm:px-0">
                <label className="block mb-2 text-base text-white">
                  Let's stay in touch. Make your inbox SHINE!
                </label>
                <form className="flex w-full max-w-md">
                  <input 
                    id="email" 
                    className="w-full px-4 py-3 rounded-l-lg border-none focus:outline-none focus:ring-2 focus:ring-teal-500"
                    type="email" 
                    placeholder="Email"
                  />
                  <button 
                    className="bg-teal-500 hover:bg-teal-600 text-white py-3 px-6 rounded-r-lg transition-colors"
                    type="button"
                  >
                    →
                  </button>
                </form>
              </div>

              <div className="flex flex-row items-center px-5 mt-4 text-left sm:px-0">
                <span className="text-base text-white">Follow Us:</span>
                {/* <div className="flex flex-row space-x-2 mt-0 ml-3">
                  {socialIcons.map(({ IconComponent, label, href }) => (
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-teal-500 transition-colors"
                      aria-label={`Follow us on ${label}`}
                    >
                      <IconComponent className="w-5 h-5 text-white" />
                    </a>
                  ))}
                </div> */}
              </div>
            </div>

            {/* Links */}
            <div className="flex flex-col items-center pl-0 mt-6 space-y-4 xl:pl-20 lg:space-y-0 lg:space-x-4 lg:flex-row xl:basis-4/5 xl:justify-around lg:justify-center lg:mt-8 xl:mt-0">
              {Object.entries(footerLinks).map(([category, links]) => (
                <div key={category} className="flex flex-col justify-center space-y-4 text-center xl:basis-1/5 lg:basis-1/3 xl:items-start xl:text-left">
                  <h4 className="font-bold text-white mb-2">{category}</h4>
                  {links.map((link) => (
                    // Use Link for internal links, <a> for external
                    link === "Twitter" || link === "Facebook" || link === "Instagram" || link === "YouTube" ? (
                      <a
                        key={link}
                        href={
                          link === "Twitter" 
                            ? "https://x.com/GiveSendGo" 
                            : link === "Facebook"
                            ? "https://www.facebook.com/Givesendgo"
                            : link === "Instagram"
                            ? "https://www.instagram.com/givesendgo"
                            : "https://www.youtube.com/channel/UCJH25w0hSD6Kx_hud1rVWuw"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link}
                      </a>
                    ) : (
                      <Link
                        key={link}
                        to={`/${link.toLowerCase().replace(/\s+/g, '-')}`}
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link}
                      </Link>
                    )
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Copyright */}
          <div className="flex justify-center p-5 bg-black/50 mt-8">
            <p className="text-gray-300">©{new Date().getFullYear()}DonatePe</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;